// Lucide icon: chevron-left (https://lucide.dev/icons/chevron-left)
import { ChevronLeft } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconChevronLeft = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <ChevronLeft />
    </IconComponentStyled>
  )
}
